
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import { l as labelsMixin } from './labels-mixin.js';
import { _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import Dropdown from 'element-ui/lib/dropdown';
import DropdownMenu from 'element-ui/lib/dropdown-menu';
import DropdownItem from 'element-ui/lib/dropdown-item';

const SCROLL_BLOCK_CLASS = 'pendo-components--is-blocking-scroll';
const THEME_CLASSES_MAP = {
  dark: 'p2-dark',
  'p2-dark': 'p2-dark',
  p2: 'p2-light',
  'p2-light': 'p2-light',
  app: 'app',
  via: 'via'
};
var script = {
  name: 'PendoDropdown',
  components: {
    ElDropdown: Dropdown,
    ElDropdownMenu: DropdownMenu,
    ElDropdownItem: DropdownItem
  },
  mixins: [labelsMixin],
  inheritAttrs: false,
  props: {
    theme: {
      type: String,
      default: 'p2-light'
    },
    items: {
      type: Array,
      default: () => []
    },
    dropdownProps: {
      type: Object,
      default: () => ({})
    },
    blockScroll: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isActive: false
    };
  },

  computed: {
    dropdownAttrs() {
      return _objectSpread({
        trigger: 'click'
      }, this.dropdownProps);
    },

    dropdownClass() {
      return [`${THEME_CLASSES_MAP[this.theme]}`, {
        'is-active': this.isActive
      }];
    }

  },
  methods: {
    setDropdownActiveWidth() {
      this.$nextTick(() => {
        const triggerWidth = this.$refs.pendoDropdown.$el.offsetWidth;
        this.$refs.pendoDropdownMenu.$el.style.minWidth = `${triggerWidth - 2}px`;
      });
    },

    handleSelect(item) {
      this.setDropdownActiveWidth();
      this.$emit('select', item);
    },

    handleVisibilityChange(visible) {
      this.isActive = visible;

      if (visible) {
        this.handleDropdownOpen();
      } else {
        this.handleDropdownClose();
      }
    },

    handleDropdownOpen() {
      if (this.blockScroll) {
        document.body.classList.add(SCROLL_BLOCK_CLASS);
      }

      this.$emit('open');
    },

    handleDropdownClose() {
      if (this.blockScroll) {
        document.body.classList.remove(SCROLL_BLOCK_CLASS);
      }

      this.$emit('close');
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-dropdown",
    class: _vm.dropdownClass
  }, [!!_vm.topLabel ? _c('div', {
    staticClass: "pendo-dropdown__label pendo-dropdown__label--top"
  }, [_vm._v("\n        " + _vm._s(_vm.topLabel) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('el-dropdown', _vm._b({
    directives: [{
      name: "pendo-analytics",
      rawName: "v-pendo-analytics",
      value: {
        type: 'components:dropdown',
        value: _vm.analyticsTagFromLabels
      },
      expression: "{ type: 'components:dropdown', value: analyticsTagFromLabels }"
    }],
    ref: "pendoDropdown",
    on: {
      "command": _vm.handleSelect,
      "visible-change": _vm.handleVisibilityChange
    }
  }, 'el-dropdown', _vm.dropdownAttrs, false), [_vm.$slots.trigger || _vm.$scopedSlots.trigger ? _c('div', {
    staticClass: "pendo-dropdown__trigger"
  }, [_vm._t("trigger", null, {
    "active": _vm.isActive
  })], 2) : _vm._e(), _vm._v(" "), _c('el-dropdown-menu', {
    ref: "pendoDropdownMenu",
    staticClass: "pendo-dropdown-menu",
    class: [_vm.dropdownClass, _vm.dropdownProps.dropdownMenuClass],
    style: _vm.dropdownProps.dropdownMenuStyles,
    attrs: {
      "slot": "dropdown"
    },
    on: {
      "hook:mounted": _vm.setDropdownActiveWidth
    },
    slot: "dropdown"
  }, _vm._l(_vm.items, function (item, index) {
    return _c('el-dropdown-item', {
      directives: [{
        name: "pendo-analytics",
        rawName: "v-pendo-analytics",
        value: {
          type: 'components:dropdown',
          value: item[_vm.$attrs['label-key']] || item.label
        },
        expression: "{ type: 'components:dropdown', value: item[$attrs['label-key']] || item.label }"
      }],
      key: "pendo-dropdown__item-" + index,
      class: _vm.dropdownProps.dropdownItemClass,
      style: _vm.dropdownProps.dropdownItemStyles,
      attrs: {
        "command": item[_vm.$attrs['value-key']] || item.value,
        "disabled": item.disabled,
        "divided": item.divided
      }
    }, [_vm._t(item[_vm.$attrs['value-key']] || item.value, [_vm._v("\n                    " + _vm._s(item[_vm.$attrs['label-key']] || item.label || item) + "\n                ")], {
      "item": item
    })], 2);
  }), 1)], 1), _vm._v(" "), !!_vm.bottomLabel ? _c('div', {
    staticClass: "pendo-dropdown__label pendo-dropdown__label--bottom"
  }, [_vm._v("\n        " + _vm._s(_vm.bottomLabel) + "\n    ")]) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-dropdown.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoDropdown = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoDropdown;
